module.exports = __webpack_public_path__ + "img/very_dissatisfied.7354891.svg";